module.exports = __webpack_public_path__ + "static/img/7.78319a56.png";